const setInitalCustomerIdData = (state, payload = {}) => {
  const {parent_vehicle_type_ids} = payload;
  if (parent_vehicle_type_ids) {
    const oldVehcleId = state;
    const newVehicleId = parent_vehicle_type_ids;

    return [...new Set([...oldVehcleId, ...newVehicleId])];
  } else return state;
};

export default (state = [], action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      return setInitalCustomerIdData(state, payload);
    }
  }
};
